import { AdminDashboardWrapper } from 'components/AdminDashboardWrapper';
import { type ReactNode, Suspense } from 'react';

import { Loader } from '@repo/ui/components/elements/Loader/Loader';

export function AdminLayout({ children }: { children: ReactNode }) {
  return (
    <AdminDashboardWrapper>
      <Suspense fallback={<Loader />}>{children}</Suspense>
    </AdminDashboardWrapper>
  );
}
